import React, { useEffect, useState } from 'react';
import classes from './Form.module.scss';
import { Slide } from '@mui/material';
import { FormPageType, useForm } from 'new/elements/Form/useForm';
import { FormPage } from 'new/elements/Form/FormPage';

interface SliderPageProps {
  index: number;
  children: FormPageType;
}

export const SliderPage = (props: SliderPageProps) => {
  const { index, children } = props;
  const { activePage } = useForm();
  const [prevPage, setPrevPage] = useState(activePage);

  useEffect(() => {
    setPrevPage(activePage);
  }, [activePage]);

  return (
    <Slide
      className={classes.slide}
      direction={prevPage > index ? 'right' : 'left'}
      in={activePage === index}
      enter={false}
      exit={false}
      appear={false}
      mountOnEnter
      unmountOnExit
    >
      <FormPage index={index}>{children}</FormPage>
    </Slide>
  );
};
